//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// components
import ValidationInvalidFeedback from '../common/ValidationInvalidFeedback.vue';
import ModalSendInformation from './ModalSendInformation.vue';

// services
import RDStationService from '../../../services/RDStationService.js';

// vendor
import {
    email,
    required,
} from 'vuelidate/lib/validators'

let followUs = {
    name: 'FollowUs',
    components: {
        ModalSendInformation,
        ValidationInvalidFeedback,
    },
    data: () => {
        return {
            followUs: {
                email: '',
            },
            responseSuccess: false,
            displayProcessingInformation: false,
        };
    },
    computed: {
    },
    validations() {
        let rules = {
            followUs: {
                email: {
                    required,
                    email,
                },
            },
        };

        return rules;
    },
    methods: {
        assetsImages:function (srcImage) {
            return window.assetsImages(srcImage);
        },
        action: function () {
            this.$v.$touch();

            this.displayProcessingInformation = false;

            if (!this.$v.followUs.email.$error) {
                this.send();
            } else {
                this.responseSuccess = false;
                this.displayProcessingInformation = true;
            }
        },
        send: function () {
            const self = this;

            const data = {
                conversion_identifier:'cadastro-newsletter',
                ...RDStationService.generateBodyParametersTraffic(),
                email: self.followUs.email,
            };

            const rdStationService = new RDStationService();

            rdStationService
                .sendEventConversion(data)
                .then(() => {
                    self.responseSuccess = true;
                    window.scrollTo({top: 0, behavior: 'smooth'});
                })
                .catch(() => {
                    self.responseSuccess = false;
                })
                .then(() => {
                    self.displayProcessingInformation = true;
                })
        },
    },
    mounted () {
    },
};

export default followUs;



// WEBPACK FOOTER //
// ./scripts/vue/components/common/FollowUs.vue